import { useTranslation } from 'react-i18next';
import { setActiveSidePanel } from '../../../grid/reduxStore/blockStyleSettingsSlice.ts';
import { SecondaryMenu } from '../../component/index.ts';
import { TableSettingsTypes } from './types.ts';

import { useAppDispatch, useAppSelector } from 'components/editor/grid/reduxStore/Store.ts';
import { useContext, useState } from 'react';
import { SidePanelAccordion } from '../../component';
import useTableAccordionData from '../useAccordionData';
import { selectTableRowStyles } from '../../../grid/reduxStore/tableRowDefaultStyleSlice.ts';
import { combineDefaultStyles } from '../combineDefaultStyles.ts';
import { selectTableTextDefaultStyles, TextDefaultStyleTypesIdentifier } from '../../../grid/reduxStore/textDefaultStylingSlice.ts';
import { DocumentSettingsContext } from '../../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext.tsx';

export function TableDefaultStyleSettings() {
  const tableTextDefaultStyles = useAppSelector(selectTableTextDefaultStyles);
  const tableRowDefaultStyle = useAppSelector(selectTableRowStyles);
  const dispatch = useAppDispatch();

  const defaultStyles = combineDefaultStyles(tableTextDefaultStyles, tableRowDefaultStyle);

  const { updateTextDefaultStyle, updateTableRowStyle } = useContext(DocumentSettingsContext);
  const accordionData = useTableAccordionData({
    defaultStyles,
    handleTextDefaultStyleUpdate: (payload) =>
      updateTextDefaultStyle({ ...payload, TextDefaultStyleTypes: TextDefaultStyleTypesIdentifier.TABLE }),
    handleRowStyleUpdate: updateTableRowStyle,
  });

  const firstAccordionTitle = accordionData[0].title.toLowerCase().replace(/\s/g, '-');
  const [expandedSection, setExpandedSection] = useState<string>(firstAccordionTitle);

  const { t } = useTranslation();

  const handleBackButtonClick = () => {
    dispatch(setActiveSidePanel({ type: TableSettingsTypes.TABLE_DEFAULTS }));
  };

  return (
    <SecondaryMenu
      testId={'default-styles-settings'}
      menuTitle={t('document.grid.table.default_styles.title')}
      backButtonOnClick={handleBackButtonClick}
      rowGap="0px"
    >
      {accordionData?.map((accordion, index) => {
        return (
          <SidePanelAccordion
            key={`accordion-${index}`}
            title={accordion.title}
            textStyleAccordion={accordion.textStyles}
            rowStyleAccordion={accordion.rowStyles}
            expanded={expandedSection}
            onChange={(value) => setExpandedSection(value)}
          />
        );
      })}
    </SecondaryMenu>
  );
}
